<template>
  <b-modal
    :id="id"
    :title="title"
    centered
    :no-close-on-backdrop="loading"
    modal-class="delete-confirmation-modal"
    footer-class="modal-footer--centered"
    @hidden="$emit('hidden')"
  >
    <div class="delete-confirmation">
      <!-- Text (per Slot überschreibbar); das Label wird nur angezeigt, wenn es gesetzt ist -->
      <p class="delete-confirmation__message">
        <slot>
          Soll {{ entityBezeichnung }}
          <template v-if="label">
            <strong>"{{ label }}"</strong>
          </template>
          wirklich gelöscht werden?
        </slot>
      </p>

      <p v-if="showIrreversibleHint" class="delete-confirmation__hint">
        Diese Aktion kann nicht rückgängig gemacht werden.
      </p>
    </div>

    <template #modal-footer>
      <button
        type="button"
        class="btn delete-confirmation__btn delete-confirmation__btn--cancel"
        :disabled="loading"
        @click="onCancel"
      >
        {{ cancelTitle }}
      </button>
      <button
        type="button"
        class="btn delete-confirmation__btn delete-confirmation__btn--confirm"
        :disabled="loading"
        @click="onConfirm"
      >
        <b-spinner v-if="loading" small class="mr-2"></b-spinner>
        {{ confirmTitle }}
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'DeleteConfirmationModal',
  props: {
    // Modal-ID zum Öffnen/Schließen
    id: { type: String, required: true },
    title: { type: String, default: 'Löschen?' },
    // fett dargestellter Name im Text
    label: { type: String, default: '' },
    entityBezeichnung: { type: String, default: 'der Eintrag' },
    confirmTitle: { type: String, default: 'Löschen' },
    cancelTitle: { type: String, default: 'Abbrechen' },
    showIrreversibleHint: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
  },
  methods: {
    onConfirm() {
      this.$emit('confirm');
    },
    onCancel() {
      this.$emit('cancel');
      this.$bvModal.hide(this.id);
    },
  },
};
</script>

<style lang="scss" scoped>
.delete-confirmation > p:last-child {
  margin-bottom: 0;
}

.delete-confirmation__message {
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0px;
  color: var(--text-body);
  margin-bottom: 12px;
}

.delete-confirmation__message :deep(strong) {
  font-family: Poppins;
  font-weight: 600;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0px;
  color: var(--text);
}

.delete-confirmation__hint {
  font-family: Poppins;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0px;
  color: var(--text-body);
}

.delete-confirmation__btn.btn {
  width: 140px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--border);
}

.delete-confirmation__btn--cancel {
  background-color: var(--surface);
  color: var(--text-body);
}

.delete-confirmation__btn--cancel:hover {
  background-color: var(--surface-hover);
}

.delete-confirmation__btn--confirm.btn {
  background-color: #d4183d;
  border-color: #d4183d;
  color: #ffffff;
}

.delete-confirmation__btn--confirm.btn:hover {
  background-color: #b41434;
  border-color: #b41434;
  color: #ffffff;
}
</style>
